import { render } from "./TransparencySection.vue?vue&type=template&id=f32c113c&scoped=true"
const script = {}

import "./TransparencySection.vue?vue&type=style&index=0&id=f32c113c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f32c113c"]])

export default __exports__